(function () {
  "use strict";

  // Sticky buy bar: show after the visitor scrolls past the hero
  var hero = document.querySelector(".hero");
  var bar = document.getElementById("stickyBar");
  var checkout = document.getElementById("checkout");

  if (hero && bar && "IntersectionObserver" in window) {
    var pastHero = false;
    var nearCheckout = false;

    var update = function () {
      var show = pastHero && !nearCheckout;
      bar.classList.toggle("show", show);
      bar.setAttribute("aria-hidden", show ? "false" : "true");
    };

    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(hero);

    // Hide the bar while the checkout embed is on screen — no need to nag
    if (checkout) {
      new IntersectionObserver(function (entries) {
        nearCheckout = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 }).observe(checkout);
    }
  }

  // Scroll-reveal animations (skipped for reduced-motion users via CSS)
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          ro.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  // Footer year
  var year = document.getElementById("year");
  if (year) year.textContent = String(new Date().getFullYear());
})();
